import { API } from 'helpers/api/endpoints';
import useData from 'hooks/useData';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

type Props = {
  software_type: string;
  setLicenseType: Dispatch<SetStateAction<string>>;
};

export default function LicenceTypeDropdown({
  setLicenseType,
  software_type,
}: Readonly<Props>) {
  const { t } = useTranslation('licenses');
  const { data, loading } = useData<string[]>(
    API.licence.licenseTypes(software_type)
  );
  useEffect(() => {
    if (Array.isArray(data)) setLicenseType(data[0] ?? '');
    return () => setLicenseType('');
  }, [data, setLicenseType]);
  if (loading) return <></>;
  // No selectable types (e.g. Flowster AI Studio — plan is part of the signed key)
  if (data && Array.isArray(data) && data.length === 0) return <></>;
  if (data && Array.isArray(data)) {
    const options = data
      ?.map((software) => ({
        label: software,
        value: software,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return (
      <>
        <Form.Label className="mb-1 mt-2 fs--1">{t('type')}</Form.Label>
        {options && (
          <Select
            classNamePrefix="react-select"
            defaultValue={options[0]}
            options={options}
            onChange={(e) => {
              if (!e) return;
              setLicenseType(e.value);
            }}
          />
        )}
      </>
    );
  }
  return <></>;
}
